import { getFeedsComments } from '@/pages/opinion/services';
import React, { useEffect, useState } from 'react';
import { useTablePropsInfo } from '@/pages/opinion/hooks/common';
import { ChannelType } from '@op/pages/stats/Detail';
import TableCommonHook from '@op/components/TableCommonHook';
import { useRequestLatestEditLog } from '@op/pages/feeds/hooks/useFeedsRequest';
import { useSocialMediaColumns } from '@op/components/TableCommonHook/hooks/useSocialMediaColumns';
import { useGameStoreColumns } from '@op/components/TableCommonHook/hooks/useGameStoreColumns';
import { useCancelRequestHook } from '@op/hooks/useCancelRequest';
import { LanguageType } from '@op/types/common';
import { getSortOptions } from '@op/pages/feeds/constants/filter';
import { useUpdateEffect } from 'ahooks';
function createTableComponent(useCustomHooks: any) {
  return function CommonTable({
    setSortBy,
    sortBy,
    channelType,
    filter,
    selectKeyword,
    backCommentTotal = (_value: number) => { },
    backLoading = (_value: boolean) => { },
    renderKeyword,
    gameInfo,
    wholeGameInfo,
    setSortByOptions,
    defaultLanguages = ['origin'],
  }: {
    setSortBy: any;
    sortBy: any;
    channelType: ChannelType;
    filter: any;
    selectKeyword: any;
    backCommentTotal?: (value: number) => void;
    backLoading?: (value: boolean) => void;
    renderKeyword: any;
    gameInfo: any;
    wholeGameInfo: any;
    setSortByOptions: (value: { text: string; value: string }[]) => void;
    defaultLanguages?: LanguageType[];
  }) {
    const {
      data,
      setData,
      pageInfo,
      changePageInfo,
      resetPageInfo,
      total,
      setTotal,
      loading,
      setLoading,
    } = useTablePropsInfo<any>({
      defaultPageInfo: { page: 1, page_size: 10 },
    });

    const [languages, setLanguages] = useState<LanguageType[]>(defaultLanguages);
    const { wrapperRequestTile } = useCancelRequestHook({
      clear: () => {
        setData([]);
        setTotal(0);
      },
    });

    const setLoadingFunc = (value: boolean) => {
      setLoading(value);
      backLoading?.(value);
    };

    const fetchComments = async (params: any) => {
      setLoadingFunc(true);

      wrapperRequestTile(getFeedsComments, params)
        .then((data) => {
          const { list, total } = data || {};
          setData(list || []);
          setTotal(total || 0);
          backCommentTotal(total || 0);
        })
        .catch(() => { })
        .finally(() => {
          setLoadingFunc(false);
        });
    };

    useEffect(() => {
      if (!filter?.edition_unified_id) return;
      const params = {
        ...filter,
        statistics_field: filter?.statistics_field || 'keyword',
        channel_type: channelType,
        sort_item: sortBy.by,
        sort_model: sortBy.order,
        keyword: selectKeyword,
        ...pageInfo,
      };
      fetchComments(params);
    }, [pageInfo]);

    useUpdateEffect(() => {
      resetPageInfo();
    }, [sortBy, filter, selectKeyword]);

    const { logCommentMap, loading: logLoading } = useRequestLatestEditLog({
      data,
    });

    const { columns, sortColumns, selectSortKeys } = useCustomHooks({
      gameInfo,
      wholeGameInfo,
      languages,
      sort: sortBy,
      setSort: setSortBy,
      logCommentMap,
      logLoading,
      setLanguages,
      renderKey: renderKeyword,
    });

    useEffect(() => {
      const orderOptions = getSortOptions(selectSortKeys);
      setSortByOptions(orderOptions);
    }, []);

    return (
      <TableCommonHook
        minWidth={1600}
        recordKey="comment_uin"
        records={data}
        tableSticky
        sortColumns={sortColumns}
        hasPageable
        sortInfo={[sortBy, setSortBy]}
        pageInfo={pageInfo}
        columns={columns}
        total={total}
        loading={loading}
        setPageInfo={changePageInfo}
      />
    );
  };
}

export const SocialMediaTable = createTableComponent(useSocialMediaColumns);
export const GameStoreTable = createTableComponent(useGameStoreColumns);
export { default as VideoTagTable } from './VideoTagTable';
